module.exports = __webpack_public_path__ + "static/PlayfairDisplay-Bold-08bb07b25c575e4dee0fcb4ea375ddc5.woff";